import * as React from "react";
import { useReminders, type UseRemindersReturn } from "@/hooks/use-reminders";

// ─── Context ─────────────────────────────────────────────────────────────────

const RemindersContext = React.createContext<UseRemindersReturn | null>(null);

// ─── Provider ─────────────────────────────────────────────────────────────────

export function RemindersProvider({ children }: { children: React.ReactNode }) {
  const remindersData = useReminders();

  return (
    <RemindersContext.Provider value={remindersData}>
      {children}
    </RemindersContext.Provider>
  );
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useRemindersContext(): UseRemindersReturn {
  const ctx = React.useContext(RemindersContext);
  if (!ctx) {
    throw new Error(
      "useRemindersContext must be used within a RemindersProvider"
    );
  }
  return ctx;
}
